<script setup lang="ts">
import { computed } from 'vue'
import { VBadge } from '@/modules/shared/components'
import { AccreditationStatuses, type AccreditationStatus } from '../types'

const props = defineProps<{
  status: AccreditationStatus
}>()

const state = computed(() => {
  switch (props.status) {
    case AccreditationStatuses.Accredited:
      return {
        color: 'v-blue',
        label: 'Accredited Investor',
      }
    case AccreditationStatuses.QualifiedPurchaser:
      return {
        color: 'v-blue',
        label: 'Qualified Purchaser',
      }
    case AccreditationStatuses.NotAccredited:
      return {
        color: 'gray',
        label: 'Non-Accredited Investor',
      }
  }
})
</script>

<template>
  <VBadge v-if="state" :color="state.color">{{ state.label }}</VBadge>
</template>
